import { createSafeContext } from '../utils/create-safe-context';
import { type OverlayData } from './reducer';

export const createOverlaySafeContext = () => {
  const [OverlayContextProvider, useOverlayContext] =
    createSafeContext<OverlayData>('vds/OverlayContext');

  const useCurrentOverlay = () => {
    return useOverlayContext().current;
  };

  const useOverlayData = () => {
    return useOverlayContext().overlayData;
  };

  return { OverlayContextProvider, useCurrentOverlay, useOverlayData };
};
